import React, { useCallback, useRef, useState, useMemo } from 'react';
import { Title } from '@landing/ui';
import { Container, Tabs } from 'components/UI';
import { Slider, SliderControl } from 'components/Slider';
import ArtImage from './ArtImage';

import * as styles from './Artworks.module.scss';

export default function Artworks({ title, artists }) {
  const sliderRef = useRef(null);
  const [current, setCurrent] = useState(1);
  const [activeFilter, setActiveFilter] = useState(artists[0].name);
  const [popupOpen, setPopupOpen] = useState(false);
  const [sliderReinitTrigger, setSliderReinitTrigger] = useState(null);
  const filters = artists.map(artist => artist.name);

  const setCurrentIndex = useCallback((prev, next) => {
    setCurrent(next + 1);
  }, []);

  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };

  const filterArts = name => {
    setActiveFilter(name);
    setCurrent(1);
    setSliderReinitTrigger(name);
    sliderRef.current.slickGoTo(0);
  };

  const filteredArtist = useMemo(
    () => artists.find(artist => artist.name === activeFilter).name,
    [activeFilter],
  );

  const filteredArts = useMemo(
    () => artists.find(artist => artist.name === activeFilter).items,
    [activeFilter],
  );

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    infinite: false,
    draggable: false,
    swipe: !popupOpen,
  };

  return (
    <Container className={styles.container}>
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <div className={styles.content}>
          <Tabs tabs={filters} active={activeFilter} handleClick={filterArts} />
          <div className={styles.slider} key={sliderReinitTrigger}>
            <Slider ref={sliderRef} beforeChange={setCurrentIndex} {...settings}>
              {filteredArts.map((item, i) => (
                <ArtImage
                  key={i}
                  index={i}
                  item={item}
                  items={filteredArts}
                  name={filteredArtist}
                  year="2023"
                  setPopupOpen={setPopupOpen}
                />
              ))}
            </Slider>
          </div>
          {filteredArts.length > 1 && (
            <SliderControl
              className={styles.controls}
              current={current}
              to={filteredArts.length}
              handleNext={handleNext}
              handlePrev={handlePrev}
              theme="reverse"
              infinite={false}
            />
          )}
        </div>
      </div>
    </Container>
  );
}
